import { Immutable } from "immer";
import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import type { HomeBannerAd as Value } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import leadInStyles from "../../styles/composable/lead-in.module.scss";
import panelStyles from "../../styles/composable/panel.module.scss";

type IProps = Immutable<{
    value: Value | null;
}>;

/**
 * Faithful JSX transcription of the legacy sealy
 * ``components/adverts/home_banner_ad.html`` (#33285). The block is a
 * value-less StaticBlock: the serialized value is an empty object (or null on
 * the standalone template path) and is ignored.
 */
export const HomeBannerAd = (_props: IProps): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <section
            className={concatClassNames([
                panelStyles.panel,
                panelStyles.panelCenter,
            ])}
            style={{
                backgroundImage: `url(${staticURL}img/advert/panel-bg-history.jpg)`,
            }}
        >
            <div
                className={concatClassNames([
                    panelStyles.panelContent,
                    panelStyles.panelContentInverse,
                ])}
            >
                <div
                    className={concatClassNames([
                        leadInStyles.leadIn,
                        "container",
                    ])}
                >
                    <h3 className="lead-in__headline">
                        {t`An American legacy for 130 years`}
                    </h3>
                    <p className={leadInStyles.leadInCopy}>
                        {t`Since 1881, millions of people have experienced the exceptional comfort, support, and durability only Sealy can deliver.`}
                    </p>
                    <div className={leadInStyles.leadInLink}>
                        <a
                            className="text-link"
                            href="/about-sealy"
                            title={t`See Our History`}
                        >
                            {t`See Our History`}
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};
